module.exports = __webpack_public_path__ + "static/003-cf1bf646b1369c38f10539627fd09f8b.png";